module.exports = function sin (arg) {
  //  discuss at: https://locutus.io/php/sin/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: Math.ceil(sin(8723321.4) * 10000000)
  //   returns 1: -9834330

  return Math.sin(arg)
}
